import {
  memo,
  PropsWithChildren,
  useState,
  useRef,
  useCallback,
  useEffect,
} from 'react';
import { useDropdown, SubContext } from '../dropdown.context';

export const Sub = memo(({ children }: PropsWithChildren<unknown>) => {
  const [open, setOpen] = useState<boolean>(false);
  const triggerRef = useRef<HTMLElement>(null);
  const { registerChild } = useDropdown();

  const close = useCallback(() => setOpen(false), []);
  const toggle = useCallback(() => setOpen((v) => !v), []);

  useEffect(() => {
    if (open) {
      return registerChild(close);
    }
  }, [open, registerChild, close]);

  return (
    <SubContext.Provider value={{ open, triggerRef, toggle, close }}>
      {children}
    </SubContext.Provider>
  );
});

Sub.displayName = 'Dropdown.Sub';
